module.exports = __webpack_public_path__ + "img/h3.cb6475a9.jpg";